<div class="resize-image">
    <a href="#" (click)="resizeImage($event)">Resize Image</a>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/image.rezise/image.resize.component.html